import { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';
import { tiresServices } from '@services';
import { parseQueryValue, showError } from '@utils';
import { useRouter } from 'next/router';
import { isEmpty } from 'lodash-es';
import { QUERY_KEYS } from '../../../constants/queryKeys';

export const useTiresEnums = () => {
  const router = useRouter();

  const enumsResponse = useQuery(
    [QUERY_KEYS.GET_MARKETPLACE_TIRES_FILTERS_KEY],
    () => tiresServices.getEnums()
  );

  const filterCategories = useMemo(() => {
    const response = enumsResponse?.data?.data;

    if (!response || response?.length === 0) {
      return [];
    }

    return response.categories.map((category) => {
      return {
        id: category.id,
        label: category.name,
        options: category.options,
        multiSelect: category.multiselect,
      };
    });
  }, [enumsResponse?.data?.data]);

  useEffect(() => {
    if (enumsResponse?.error) {
      showError(enumsResponse?.error);
    }
  }, [enumsResponse?.error]);

  const currentFilters = useMemo(() => {
    const response = enumsResponse?.data?.data;

    const filters = {};

    if (!response || response?.length === 0 || isEmpty(router.query)) {
      return filters;
    }

    response.categories.forEach((category) => {
      const value = parseQueryValue(router.query[category.id]);

      if (isEmpty(value)) {
        return;
      }

      filters[category.id] = value;
    });

    return filters;
  }, [router.query, enumsResponse?.data?.data]);

  const filterConfig = {
    filterCategories,
    currentFilters,
  };

  return {
    error: enumsResponse?.error,
    isSuccess: enumsResponse?.isSuccess,
    loading: enumsResponse?.isLoading || enumsResponse?.isFetching,
    filterConfig:
      filterConfig.filterCategories.length > 0 ? filterConfig : null,
  };
};
